export default { sha: '5ec18cdd208bb5a775ae019eeb5b8cda301cff8b', buildNumber: 'undefined' }
